import { createRemoteComponent, createRequires } from '@paciolan/remote-component';
import { resolve } from "./remote-component.config.js";
var requires = createRequires(() => resolve);
export var RemoteComponent = createRemoteComponent({
  requires
});
export default RemoteComponent;
//# sourceMappingURL=RemoteComponent.js.map